import { z } from "zod";

export type ZodEmptyObject = z.ZodObject<{}>;

export const centraAddressSchema = z.object({
  address1: z.string().min(1, "Address is required"),
  address2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  country: z.string().min(1, "Country is not valid"),
  email: z.string().email("Invalid email address"),
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  phoneNumber: z.string().optional(),
  company: z.string().optional(),
  state: z.string().optional(),
  vatNumber: z.string().optional(),
  zipCode: z.coerce.string().min(1, "Postal code is required"),
});

export type CentraAddress = z.infer<typeof centraAddressSchema>;

export type CustomAddress<
  T extends ZodEmptyObject | undefined = undefined,
  Schema extends ZodEmptyObject = typeof centraAddressSchema,
> = T extends ZodEmptyObject
  ? z.infer<z.ZodIntersection<Schema, T>>
  : z.infer<Schema>;
